<template>
<div class="chapter">
<div class="inner_page">
<h2 class="partnumber"><a id="h7">PART I</a></h2><a id="h7">
<h2 class="parttitle">INTO THE SALIENT</h2>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_part01.vue?0685006b